module.exports = __webpack_public_path__ + "img/a11a796.png";